import { render } from "./PasswordReset.vue?vue&type=template&id=0e223dba&ts=true&lang=pug"
import script from "./PasswordReset.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordReset.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__